import * as React from 'react';
import { ErrorWrapper } from '../ErrorWrapper';
import { pointerIcon } from '../../icons';
import { generateErrorBannerShowAction } from '../../../../../../../../actions/webview';
import { AppContext } from '../../../../../../../../../AppModulesWrapper';

export const GeoEmpty = () => {
  const { webview } = React.useContext(AppContext);

  React.useEffect(() => {
    webview.sendAction(generateErrorBannerShowAction('geo-empty-client-error-show'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ErrorWrapper icon={pointerIcon}>
      Введите адрес объекта, чтобы увидеть, сколько звонков можно получить со&nbsp;ставкой
    </ErrorWrapper>
  );
};
